<div class="d-flex align-items-center justify-content-between">
  <span class="message-text" [innerHTML]="message"></span>

  <button mat-raised-button (click)="dismiss()">
    {{ 'Foundation.OK' | translate }}
  </button>
</div>